// extracted by mini-css-extract-plugin
export default {"csTabs":"CsTabs__csTabs__Qr9K1","bigSize":"CsTabs__bigSize__rnxXR","csTabsHiddenOperations":"CsTabs__csTabsHiddenOperations__EiRr6"};